<template>
  <section class="container-section">
    <loading
      :active="isLoading"
      :is-full-page="true"
    />
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Tramitación aduanal
        </h3>
      </section>
      <section>
        <div class="list-items">
          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="proceduresAndPermits.dua"
                class="uk-checkbox"
                type="checkbox"
              >  DUA Importación
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="proceduresAndPermits.customsServiceFee"
                class="uk-checkbox"
                type="checkbox"
              > Tasa de Servicio Aduanero
            </label>
          </div>

          <div>
            <div class="items">
              <label style="cursor: pointer">
                <input
                  v-model="proceduresAndPermits.customsInspection"
                  class="uk-checkbox"
                  type="checkbox"
                > Inspección Aduanal (Reemplazo de Sello)
              </label>
            </div>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="proceduresAndPermits.customsInspectionExpenses"
                class="uk-checkbox"
                type="checkbox"
              >  Gastos inspección aduanera
            </label>
          </div>

          <div class=" uk-flex items uk-flex-wrap">
            <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="proceduresAndPermits.freeZone"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="proceduresAndPermits.dispatchFreeTradeZone = null"
                > ¿El producto va a Zona Franca?
              </label>
            </div>
            <div class="uk-form-controls uk-form-width-medium">
              <select
                id="timeCharger"
                v-model="proceduresAndPermits.dispatchFreeTradeZone"
                :disabled="proceduresAndPermits.freeZone == null || proceduresAndPermits.freeZone == false"
                class="uk-select filterDistance"
                style="margin-top: 5px"
              >
                <option
                  v-for="freeZone in freeZoneExports"
                  :key="freeZone.id"
                  :value="freeZone.id"
                >
                  {{ freeZone.description }}
                </option>
              </select>
            </div>
          </div>

          <div
            class="items uk-flex uk-flex-wrap "
            style="width: 100%"
          >
            <div class="sub-items uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="proceduresAndPermits.vegetableInspection"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="changeVegetableInspection"
                >   Inspección  Sanidad Vegetal
              </label>
            </div>

            <div
              v-if="proceduresAndPermits.vegetableInspection"
              class="sub-items"
            >
              <label
                style="cursor: pointer"
                class="sub-items-label InputColumn"
              >
                <input
                  v-model="proceduresAndPermits.plantHealthInspection"
                  class="uk-form-width-small uk-input uk-width-small filterDistance"
                  style="margin-top: 5px"
                  type="number"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyNumber($event)"
                > Costo de Inspección
              </label>
            </div>
          </div>

          <div class="items uk-flex uk-flex-wrap">
            <div class="sub-items uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="proceduresAndPermits.animalInspection"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="changeAnimalInspection"
                >   Inspección  Sanidad animal
              </label>
            </div>

            <div
              v-if="proceduresAndPermits.animalInspection"
              class="sub-items"
            >
              <label
                style="cursor: pointer"
                class="sub-items-label InputColumn"
              >
                <input
                  v-model="proceduresAndPermits.animalHealthInspection"
                  class="uk-form-width-small uk-input uk-width-small filterDistance"
                  style="margin-top: 5px"
                  type="number"
                  min="0"
                  max="9999999"
                  @keydown="$helperPlugin.onlyNumber($event)"
                > Costo de Inspección
              </label>
            </div>
          </div>

          <div class="img-tramitacion">
            <a
              target="_blank"
              href="https://vucerd.gob.do/"
            >
              <img src="../../../../assets/img/tramite.png">
              Enlace a Vuce RD</a>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      proceduresAndPermits: {
        dua: null,
        plantHealthInspection: null,
        animalHealthInspection: null,
        dispatchFreeTradeZone: null,
        freeZone: null,
        customsServiceFee: null,
        customsInspection: null,
        customsInspectionExpenses: null,

        vegetableInspection: null,
        animalInspection: null
      },
      healthAnimal: [],
      healthVegetable: [],
      freeZoneExports: [],
      isLoading: false

    }
  },

  computed: {
    ...mapGetters([
      'proceduresAndPermitsStore'
    ])
  },

  watch: {
    proceduresAndPermits: {
      handler: function (newVal) {
        this.$store.commit('setProceduresAndPermits', newVal)
      },
      deep: true
    },
    'proceduresAndPermits.plantHealthInspection': async function (newVal, oldVal) {
      if (this.proceduresAndPermits.plantHealthInspection > 9999999) this.proceduresAndPermits.plantHealthInspection = oldVal
    },
    'proceduresAndPermits.animalHealthInspection': async function (newVal, oldVal) {
      if (this.proceduresAndPermits.animalHealthInspection > 9999999) this.proceduresAndPermits.animalHealthInspection = oldVal
    }
  },
  async mounted () {
    await this.init()
    this.proceduresAndPermits = { ...this.proceduresAndPermitsStore }
  },
  methods: {
    changeVegetableInspection () {
      if (this.proceduresAndPermits.vegetableInspection) this.proceduresAndPermits.plantHealthInspection = 2000
      else this.proceduresAndPermits.plantHealthInspection = 0
    },
    changeAnimalInspection () {
      if (this.proceduresAndPermits.animalInspection) this.proceduresAndPermits.animalHealthInspection = 1000
      else this.proceduresAndPermits.animalHealthInspection = 0
    },
    async init () {
      this.isLoading = true
      try {
        const data = await this.$services.transportChainScenarioService.getChoices()
        this.healthAnimal = data.animalHealthInspections
        this.healthVegetable = data.plantHealthInspections
        this.freeZoneExports = data.freeZoneExports
      } catch (e) {
        this.$toast.warning('No se pudo obtener los datos, contáctese con su administrador.', {
          position: 'top',
          duration: 4000
        })
      }
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
*{
  box-sizing: border-box;
  font-size: 12px;
}
p {

  margin: 10px;
}
.container-section{
  padding: 10px 40px;
}

.sub-container{
  min-height: 418px;;
}
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
section{
  width: 98%;
  padding: 10px 10px 20px;
  }

.title{
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 16px;
}

.section-titles{
  width: 85%;
  padding: 0px
}
.img-tramitacion{
  width: 100%;
}
.img-tramitacion img{
  margin-right: 5px;
}
.btn{
  padding-right:25px ;
}

.list-items{
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
}
.items{
  margin-right: 30px;
  margin-bottom: 30px;
  min-width: 300px;
}

@media screen and (max-width: 1299px){
  .items{
    min-width: 200px;
  }
}
@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .container-section{
    padding: 10px 20px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
  }
  .items{
    min-width: 130px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;

  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }

}
@media screen and (max-width: 427px){
  .sub-items{
    margin-top: 5px;
  }
}
 @media screen and (max-width: 376px){
  .InputColumn {
   display: flex;
   flex-direction: column;
   width: 95%;
  margin: 10px 0 !important;
  }

.filterDistance{
  min-width: 270px;
  max-width: 300%;
  width: 100%;
}

.items{
  margin-right: 20px;
  margin-bottom: 30px;
  min-width: 300px;
}

}
</style>
